import React from "react";
import { Layout } from "../components/Layout";
import { Profile } from "../components/Profile";
import Skills from "../components/Skills";
import WhatIDo from "../components/WhatIDo";

const Home = () => {
  return (
    <Layout>
      <Profile />
      <WhatIDo />
      <Skills />
    </Layout>
  );
};
export default Home;
